import { createSvgIcon } from '@mui/material/utils'

export const YouTubeIcon = createSvgIcon(
  <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1.25 3.07734)">
      <path
        d="M9.90391 0H2.59609C1.16231 0 0 1.16231 0 2.59609V6.24923C0 7.68301 1.16231 8.84532 2.59609 8.84532H9.90391C11.3377 8.84532 12.5 7.68301 12.5 6.24923V2.59609C12.5 1.16231 11.3377 0 9.90391 0ZM8.14819 4.6004L4.73009 6.23063C4.63901 6.27406 4.5338 6.20766 4.5338 6.10676V2.74441C4.5338 2.64208 4.64177 2.57575 4.73304 2.62201L8.15115 4.35414C8.25277 4.40563 8.25101 4.55137 8.14819 4.6004Z"
        fill="currentColor"
      />
    </g>
  </svg>,
  'YouTube',
)
